import {
  ButtonIcon,
  EditActionIcon,
  DeleteActionIcon,
  RoundedIconVisibility,
  AccountsRoundedIconManage,
} from 'components/Ui/styled';
import { ActionWrapperBox } from 'components/Common/common.styled';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

const renderTutoringSubjectsV2Actions = (params, handleEdit, handleDelete) => {
  return (
    <ActionWrapperBox>
      <ButtonIcon onClick={() => handleEdit(params)}>
        <EditActionIcon />
      </ButtonIcon>
      <ButtonIcon onClick={() => handleDelete(params)}>
        <DeleteActionIcon />
      </ButtonIcon>
    </ActionWrapperBox>
  );
};

const renderViewAction = (params, handleView) => {
  return (
    <ActionWrapperBox>
      <ButtonIcon onClick={() => handleView(params)}>
        <RoundedIconVisibility />
      </ButtonIcon>
    </ActionWrapperBox>
  );
};

const renderManageTutorsAction = (params, handleView) => {
  return (
    <ActionWrapperBox>
      <ButtonIcon onClick={() => handleView(params)}>
        <AccountsRoundedIconManage />
      </ButtonIcon>
    </ActionWrapperBox>
  );
};

export const tutoringSubjectsV2Columns = (
  handleEdit,
  handleDelete,
  handleView,
  handleManageTutors
) => [
  {
    field: 'action',
    headerName: 'Action',
    sortable: false,
    disableColumnMenu: true,
    width: 80,
    renderCell: (params) =>
      renderTutoringSubjectsV2Actions(params, handleEdit, handleDelete),
  },
  {
    width: 100,
    sortable: false,
    field: 'manageTutors',
    disableColumnMenu: true,
    headerName: 'Manage Tutors',
    renderCell: (params) =>
      renderManageTutorsAction(params, handleManageTutors),
  },
  {
    width: 100,
    sortable: false,
    field: 'viewTimeslots',
    disableColumnMenu: true,
    headerName: 'View Timeslots',
    renderCell: (params) => renderViewAction(params, handleView),
  },
  {
    flex: 1,
    field: 'subjectName',
    headerName: 'Subject Name',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    field: 'primaryTutors',
    headerName: 'Primary Tutors',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    field: 'backupTutors',
    headerName: 'Backup Tutors',
    renderCell: renderCellExpand,
  },
];

export const getTutoringSubjectsV2ListData = (
  subjects,
  subjectTutorsMap,
  availableUsersList
) => {
  if (!subjects || subjects.length === 0) return [];

  return subjects.map((item) => {
    const tutors = subjectTutorsMap[item.subjectId] || [];

    const getTutorsByCategory = (category) => {
      return tutors
        .filter((t) => t.category === category)
        .map((t) => {
          const user = availableUsersList.find((u) => u.userId === t.tutorId);
          return user ? `${user.givenName} ${user.familyName}` : t.tutorId;
        })
        .join(', ');
    };

    const primaryTutors = getTutorsByCategory('primary');
    const backupTutors = getTutorsByCategory('backup');
    return {
      ...item,
      backupTutors,
      primaryTutors,
      id: item?.subjectId,
      subjectName: item?.name,
    };
  });
};
